import { RxCustomerAPI, RxKongCustomerAPI, CustomerAPI, checkStatus, json } from '@drifthq/dapper'
import config from 'config'

export const api = {
  create(settings, enableDefaultWelcomeMessages = false) {
    return RxKongCustomerAPI
      .post(`/organizations`, settings, { auth: false, clientId: true, params: { enableDefaultWelcomeMessages: enableDefaultWelcomeMessages } })
      .checkStatus()
      .pluck('response')
  },
  trackSignup(properties) {
    return RxCustomerAPI
      .post('/organizations/track_signup', properties)
      .checkStatus()
      .pluck('response')
  },
  fetch(orgId) {
    return RxCustomerAPI
      .get(`/organizations/${orgId}`)
      .checkStatus()
      .pluck('response')
  },
  fetchUsers(orgId) {
    return RxCustomerAPI
      .get(`/organizations/${orgId}/users?status=INVITED&status=ENABLED&status=ARCHIVED`)
      .checkStatus()
      .pluck('response')
  },
  checkUniqueHandle(handle) {
    return RxKongCustomerAPI.head('/organizations/handle_check', { handle })
  },
  updateProperties(id, properties) {
    return RxCustomerAPI
      .patch(`/organizations/${id}/properties`, properties)
      .checkStatus()
      .retryWithBackoff()
  },
  updateEmbed(operations) {
    return RxCustomerAPI
      .patch('/embeds/_default/configuration', operations)
      .checkStatus()
      .retryWithBackoff()
  },
  updateEmbedPromise(operations) {
    return CustomerAPI
    .patch('/embeds/_default/configuration', operations)
    .then(checkStatus)
    .then(json)
  },
  updateOrg(id, update) {
    return RxCustomerAPI
      .patch(`/organizations/${id}`, update)
      .checkStatus()
      .retryWithBackoff()
  },
  fetchOrgProperties(orgId) {
    return CustomerAPI
      .get(`/organizations/${orgId}/properties`)
      .then(checkStatus)
      .then(json)
  },
  shareEmailSnippet(email) {
    return CustomerAPI
      .post(`/snippets/send?email=${ email }`)
      .then(checkStatus)
      .then(json)
  },
  fetchEmbed() {
    return CustomerAPI.get(`/embeds/_default`)
      .then(checkStatus)
      .then(json)
  },
  rxFetchEmbed() {
    return RxCustomerAPI.get(`/embeds/_default`)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  exchangeGoogleCodeForDriftCode(payloadProps) {
    const payload = {
      code : payloadProps.code,
      clientId : config.DEFAULT_CLIENT_ID,
      anonymousId : !!window.analytics && !!window.analytics.user ? window.analytics.user().anonymousId() : "",
      redirectUri : payloadProps.externalRedirect ? `${config.LETS_GO_URL}/letsgo${payloadProps.pathname}` : config.LETS_GO_URL
    }
    return RxCustomerAPI.post(`/google/oauth/acceptCustomRedirect`, payload)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
  exchangeMicrosoftCodeForDriftCode(payloadProps) {
    const payload = {
      code : payloadProps.code,
      clientId : config.DEFAULT_CLIENT_ID,
      anonymousId : !!window.analytics && !!window.analytics.user ? window.analytics.user().anonymousId() : "",
      redirectUri : `${config.LETS_GO_URL}/letsgo${payloadProps.pathname}`
    }
    return RxCustomerAPI.post(`/microsoft/oauth/acceptCustomRedirect`, payload)
      .checkStatus()
      .retryWithBackoff()
      .pluck('response')
  },
}



// WEBPACK FOOTER //
// ./src/modules/org/api.js